<template>
  <component
    :is="tag"
    @click.native="hideSidebar"
    class="nav-item"
    v-bind="$attrs"
    tag="li"
  >
    <a :class="linkClass()">
      <slot>
        <font-awesome-icon class="nav-icon" v-if="icon" :icon="icon" />
        <p>{{ name }}</p>
      </slot>
    </a>
  </component>
</template>
<script>
export default {
  name: "sidebar-link",
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true
    },
    addLink: {
      default: () => {}
    },
    removeLink: {
      default: () => {}
    }
  },
  props: {
    name: String,
    icon: String,
    divider: Boolean,
    dividerAfter: Boolean,
    tag: {
      type: String,
      default: "router-link"
    }
  },
  methods: {
    hideSidebar() {
      if (this.autoClose) {
        this.$sidebar.displaySidebar(false);
      }
    },
    isActive() {
      return this.$el.classList.contains("active");
    },
    linkClass() {
      let cls = "nav-link";
      if (this.divider) {
        cls = cls + " with-divider";
      }
      if (this.dividerAfter) {
        cls = cls + " with-divider-after";
      }
      return cls;
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
};
</script>
<style>
.with-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.with-divider-after {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
